<template>
  <div id="page-chat-list" class="vx-card p-6">
    <vx-card ref="filterCard" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <h2>{{ bbsInfo ? (bbsInfo.title || '') : '' }}</h2>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">契約サーバー</label>
          <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    label="value" :searchable="false" :reduce="item => item.key" :options="contractServers" v-model="filterChats.contract_server">
          </v-select>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">所属企業</label>

          <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="メールアドレス" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterChats.company"
                    icon-after="true" :icon="filterChats.company ? iconVsInput : ''"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/2 flex flex-wrap items-end mt-4">
          <vs-button icon="arrow_back" color="#e0e0e0" @click="$router.back()" class="mr-6 sm:mr-3">  戻る</vs-button>
        </div>
        <div class="vx-col w-1/2 flex flex-wrap items-end justify-end div-search-bnt">
          <vs-button icon="search" @click="pageNumber = 1; searchWithOrder(); ids = []" class="search_icon mr-6 sm:mr-3">検索 </vs-button>
        </div>
      </div>
    </vx-card>
    <conversation :popup-active="conversationPopup" :faq-selected-item="selectedItem" @onClose="onCloseConversationPopup"/>
    <!-- AgGrid Table -->
    <div class="chat-list">
      <vs-row class="pl-2">
        <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
          <span class="pr-2">表示件数:</span>
          <div class="vx-col md:w-24 w-full">
            <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
          </div>
        </vs-col>
      </vs-row>
      <ag-grid-vue
              id="faq-bbs-list"
              ref="agGridTable"
              :components="components"
              :gridOptions="gridOptions"
              class="ag-theme-material w-100 my-4 ag-grid-table database"
              :columnDefs="columnFaqBbsDefs"
              :defaultColDef="defaultColDef"
              :rowData="faqBbsListCustom"
              rowSelection="single"
              colResizeDefault="shift"
              :animateRows="true"
              :pagination="true"
              :domLayout="domLayout"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              :enableRtl="$vs.rtl"
              @rowClicked="onSelectRow"
              @sortChanged="onSortChangedEvent"
              :overlayNoRowsTemplate="noRowsTemplate"
              :detailRowAutoHeight="true"
      >
      </ag-grid-vue>
      <div style="position: relative">
        <!-- ITEMS PER PAGE -->
        <div>
          <div class="flex items-center justify-between">
            <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ subTotalRows }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
          </div>
        </div>
        <vs-pagination
            :total="subTotalPages"
            v-model="currentPage"
            :max="5"
            class="pr-10 pt-10"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CellRendererActions from './CellRendererActions'
import CellRendererTitle from './CellRendererTitle'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import Conversation from './Conversation'
import CategoryList from '@/views/chat/CategoryList'
import { createNamespacedHelpers } from "vuex";
import {setupIconClickEvent} from "@/utils/helpler-utils";
import EventBus from "../../EventBus";
import {
  CONTRACT_APP_PAC,
  CONTRACT_APP_PAC2,
  getAppEnvText,
  getContractAppText,
  getContractServerText
} from "../../utils/bbsUtils";

const faqBbsModule = createNamespacedHelpers('faqBbs')

export default {
  components: {
    AgGridVue,
    CellRendererActions,
    CellRendererTitle,
    Conversation,
    CategoryList
  },
  data() {
    return {
      iconVsInput: 'close', 
      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          if(this.gridApi) this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnFaqBbsDefs: [
        {
          headerName: 'カテゴリ',
          field: 'category_name',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'タイトル',
          field: 'title',
          filter: true,
          width: 170,
          unSortIcon: true,
          cellRendererFramework: 'CellRendererTitle',
          suppressMovable: true,
        },
        {
          headerName: '投稿ユーザ',
          field: 'fullname',
          filter: true,
          width: 160,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '所属企業',
          field: 'company_name',
          filter: true,
          width: 170,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '契約ｱﾌﾟﾘｹｰｼｮﾝ',
          field: 'contract_app',
          filter: true,
          width: 140,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '契約環境',
          field: 'app_env',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '契約サーバー',
          field: 'contract_server',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '登録日時',
          field: 'created_at',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '更新者',
          field: 'last_update_user_name',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '更新日時',
          field: 'updated_at',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions,
        CellRendererTitle
      },
      conversationPopup: false,
      bbsDialogPopup: false,
      boxChat: false,
      filterChats: {
        company: '',
        contract_server: null,
      },
      contractApps: [
        { key: CONTRACT_APP_PAC, value: 'PAC'},
        { key: CONTRACT_APP_PAC2, value: 'PAC 2'},
      ],
      contractServers: [
        { key: null, value: 'アイテムを選択してください'},
        { key: 0, value: '1 号機'},
      ],
      appEnvs: [
        { key: 0, value: 'AWS'},
        { key: 1, value: 'K5'},
      ],
      stateOptions: [
        { key: 1, value: 'ご利用手順書'},
        { key: 2, value: '操作方法'},
        { key: 3, value: '不具合'},
      ],

      paginationOptions: [
        10, 20, 30, 50
      ],
      selectedItem: null,
      selectedId: null,
      isShowDetail: false,
      bbsId: null,
      bbsInfo: null,
    }
  },
  watch: {
    paginationPageSize(val){
      this.setPagination(val);
    }
  },
  computed: {
    ...faqBbsModule.mapGetters(['subFaqBbsList','faqBbsCategoryList', 'subTotalPages', 'subTotalRows']),
    currentPage: {
      get () {
        return this.$store.state.faqBbs.subFaqBbsListModel ? this.$store.state.faqBbs.subFaqBbsListModel.current_page || 1 : 1
      },
      async set (val) {
        this.pageNumber = val
        await this.fetchFaqBbsSubPost({...this.filterChats, page: val, limit: this.paginationPageSize, id: this.bbsId})
        //if(this.gridApi) this.gridApi.paginationGoToPage(val-1)
        //this.SET_BBS_LIST_CURRENT_PAGE(val)
      }
    },
    faqBbsListCustom() {
      if (!this.subFaqBbsList) return []
      return this.subFaqBbsList.map(item => {
        const new_item = Object.assign({...item},{contract_app: getContractAppText(item.contract_app), app_env: getAppEnvText(item.app_env), contract_server: getContractServerText(item.contract_server)})
        return new_item
      })
    }
  },
  methods: {
    ...faqBbsModule.mapActions(['fetchFaqBbsSubPost', 'fetchFaqBbsCommentList', 'getFaqBbs']),
    async resetColFilters () {
      // Reset Grid Filter
      if(this.gridApi) {
        this.gridApi.setFilterModel(null)
        this.gridApi.onFilterChanged()
      }
      this.filterChat = null
      this.ids = []
      await this.searchWithOrder()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    clearInput() {
      this.filterChats.company = ""; // Clear the value input
    },
    async searchWithOrder(){
      await this.fetchFaqBbsSubPost({...this.filterChats, page: this.pageNumber, limit: this.paginationPageSize, id: this.bbsId})
    },
    async onSelectRow() {
      if (!this.gridApi) return
      if (this.isShowDetail) return
      const row = this.gridApi.getSelectedRows().shift()
      if(!row) return
      this.selectedId = row.id
      this.selectedItem = await this.getFaqBbs(row.id)
      if(!this.selectedItem) return
      this.selectedItem.author_type = row.author_type
      if (!row.author_type) {
        const res = await this.fetchFaqBbsCommentList(row.id)
        if (!res) return
      }
      this.showConversation()
    },
    onSortChangedEvent(event){
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function(column){
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy  = column.getColId()
        }
      });
    },
    showConversation() {
      this.conversationPopup = true
    },
    onCloseConversationPopup() {
      this.conversationPopup = false
    },
    async setPagination(val){
      if(this.gridApi) this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      // await this.fetchFaqBbsList({page: 1, limit: val})
    }
  },
  async created() {
    this.bbsId = this.$route.params.id
    this.bbsInfo = await this.getFaqBbs(this.bbsId)
  },
  beforeMount(){
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }

    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    })
    setupIconClickEvent();
  },
  updated(){
    // calc number startRow and endRow
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.subFaqBbsList.length > 0){
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if(this.subFaqBbsList.length === this.paginationPageSize) this.endRow = this.pageNumber * this.paginationPageSize
        else this.endRow = this.paginationPageSize * this.pageNumber + this.subFaqBbsList.length - this.paginationPageSize
      }
      if(this.subFaqBbsList.length === 0){
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/view/faq-bbs.scss";
.vs-con-input .icon-after {
  right: 7px;
  top: 10px;
  border: none;
  cursor: pointer;
}
</style>